import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Field, Input } from '../../../components/ui/Field.jsx'
import { useFeedback } from '../../../components/ui/feedback.jsx'
import api from '../../../lib/api.js'

/* Step 4 — invoice numbering (required). PUT /companies/:id/invoice-numbering. */
export default function StepNumbering({ companyId, bindSubmit }) {
  const { t } = useTranslation()
  const { toast } = useFeedback()
  const [data, setData] = useState(null)
  const [pattern, setPattern] = useState('')
  const [start, setStart] = useState(1)
  const [preview, setPreview] = useState('')

  useEffect(() => {
    api.get(`/companies/${companyId}/invoice-numbering`).then(({ data: d }) => { setData(d); setPattern(d.invoice_number_pattern || 'INV-%Y-%4d'); setStart(d.invoice_number_start ?? 1) })
  }, [companyId])

  useEffect(() => {
    if (!pattern) return undefined
    const id = setTimeout(() => {
      api.post(`/companies/${companyId}/invoice-numbering/preview`, { pattern, start_number: Number(start), sequence_number: Number(start) })
        .then(({ data: d }) => setPreview(d?.preview || '')).catch(() => setPreview(''))
    }, 300)
    return () => clearTimeout(id)
  }, [pattern, start, companyId])

  useEffect(() => {
    bindSubmit(async () => {
      if (!String(pattern || '').trim()) { toast(t('setup.steps.numbering.patternRequired'), 'error'); return false }
      try { await api.put(`/companies/${companyId}/invoice-numbering`, { invoice_number_pattern: pattern, invoice_number_start: Number(start) }); return true }
      catch (e) { toast(e?.response?.data?.error || t('settings.errorGeneric'), 'error'); return false }
    })
  }, [pattern, start, companyId, bindSubmit, t, toast])

  if (!data) return <div style={{ color: 'var(--color-text-muted)' }}>{t('common.loading')}</div>
  return (
    <>
      <p style={{ color: 'var(--color-text)', fontSize: 14, marginBottom: 16 }}>{t('setup.steps.numbering.intro')}</p>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 14 }}>
        <Field label={t('settings.numbering.pattern')}><Input value={pattern} onChange={(e) => setPattern(e.target.value)} style={{ fontFamily: 'monospace' }} /></Field>
        <Field label={t('settings.numbering.start')}><Input type="number" min="1" value={start} onChange={(e) => setStart(e.target.value)} /></Field>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', background: 'var(--color-bg-lilac)', borderRadius: 10 }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '.04em' }}>{t('settings.numbering.preview')}</span>
        <span style={{ fontFamily: 'var(--font-title)', fontWeight: 700, color: 'var(--color-ink)' }}>{preview || '—'}</span>
      </div>
    </>
  )
}
